import React from 'react';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import SharePanel from '../components/SharePanel';
import MsgNetLoading from '../components/MsgNetLoading';
import TopHeaderMenu from '../components/TopHeaderMenu';
import ResultadoDetailHeader from '../components/ResultadoDetailHeader';
import ResultadoDetailTiempo from '../components/ResultadoDetailTiempo';
import ResultadoDetailMenu from '../components/ResultadoDetailMenu';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import ResultadoDetailTablaPasos from '../components/ResultadoDetailTablaPasos';
import ResultadoDetailTablaPuestos from '../components/ResultadoDetailTablaPuestos';
import ResultadoDetailTablaRankings from '../components/ResultadoDetailTablaRankings';
import { calculaPrevision } from '../utils/time';
import { deriveControlUltimoId } from '../utils/wsDelta';
import CONFIG from '../config';

class ResultadoScreenClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: 0,
      evento: null,
      sectores: [],
      controlList: [],
      resultado: null,
      competicion: null,
      botonSeleccionado: 1,
      showSharePanel: false,
      rankingsResultados: [],
      favoritos: []
    };
    this.ws = null;
    this.wsReconnectTimer = null;
  }

  toogleSharePanel() {
    this.setState({ showSharePanel: !this.state.showSharePanel });
  }

  componentDidMount() {
    const competicionId = parseInt(this.props.params.competicionId, 10);
    const dorsal = parseInt(this.props.params.dorsal, 10);

    const favoritosCookie = Cookies.get('favoritos-' + competicionId);
    if (favoritosCookie) {
      try { this.setState({ favoritos: JSON.parse(favoritosCookie) }); }
      catch (e) { this.setState({ favoritos: [] }); }
    }

    this.fetchInitData(competicionId, dorsal);
    this.connectWS(competicionId, dorsal);
    this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
  }

  fetchInitData(competicionId, dorsal) {
    fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
      .then(r => r.json())
      .then(data => {
        this.setState({
          competicion: data.competicion,
          evento: data.evento,
          sectores: data.sectores,
          controlList: data.controles,
        });
      })
      .catch(err => console.error('live-init error:', err));

    fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/dorsal/${dorsal}/rankings/`)
      .then(r => r.json())
      .then(data => this.setState({ rankingsResultados: data.resultados }))
      .catch(err => console.error('live-dorsal-rankings error:', err));
  }

  connectWS(competicionId, dorsal) {
    if (this.ws) this.ws.close();
    this.ws = new WebSocket(`${CONFIG.WS_URL}/ws/${competicionId}`);
    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.tipo === 'update' || data.tipo === 'delta') {
        const flat = (data.resultados || []).map(r => ({ ...r, ...r.controles }));
        const found = flat.find(r => r.dorsal === dorsal);
        const eliminado = (data.eliminados || []).includes(dorsal);
        let resultado = this.state.resultado;
        const ctrl = data.controles || this.state.controlList;
        if (eliminado) {
          resultado = null;
        } else if (found) {
          resultado = { ...found, control_ultimo_id: deriveControlUltimoId(found, ctrl) };
        } else if (resultado) {
          // Re-enriquecer con controles actualizados (p.ej. toggle prevision)
          resultado = { ...resultado, control_ultimo_id: deriveControlUltimoId(resultado, ctrl) };
        }
        this.setState({ resultado, controlList: ctrl });
        this.fetchRankings(competicionId, dorsal);
      }
    };
    this.ws.onclose = () => {
      this.wsReconnectTimer = setTimeout(() => this.connectWS(competicionId, dorsal), 3000);
    };
  }

  // Coalescer en cliente para el fetch de rankings: como mucho una
  // peticion en vuelo por pantalla. Si llega otra actualizacion del WS
  // mientras el fetch anterior sigue en curso, se marca "dirty" para
  // repetir una unica vez mas al terminar, en vez de disparar un fetch
  // nuevo por cada mensaje (evita el mismo storm que ya resolvimos del
  // lado de Go, aqui a nivel de peticiones REST).
  fetchRankings(competicionId, dorsal) {
    if (!this._rankingsFetchState) {
      this._rankingsFetchState = { dirty: false, inFlight: false };
    }
    const state = this._rankingsFetchState;
    state.dirty = true;
    if (state.inFlight) return;
    state.inFlight = true;
    state.dirty = false;
    this._runRankingsFetch(competicionId, dorsal);
  }

  _runRankingsFetch(competicionId, dorsal) {
    const state = this._rankingsFetchState;
    fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/dorsal/${dorsal}/rankings/`)
      .then(r => r.json())
      .then(data => this.setState({ rankingsResultados: data.resultados }))
      .catch(() => {})
      .finally(() => {
        if (state.dirty) {
          state.dirty = false;
          this._runRankingsFetch(competicionId, dorsal);
        } else {
          state.inFlight = false;
        }
      });
  }

  componentWillUnmount() {
    if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
    if (this.ws) this.ws.close();
    if (this.interval) clearInterval(this.interval);
  }

  esFavorito() {
    const dorsal = parseInt(this.props.params.dorsal, 10);
    return this.state.favoritos.indexOf(dorsal) >= 0;
  }

  onClickFavorito() {
    const competicionId = parseInt(this.props.params.competicionId, 10);
    const dorsal = parseInt(this.props.params.dorsal, 10);
    let favoritos = [...this.state.favoritos];
    const idx = favoritos.indexOf(dorsal);
    if (idx >= 0) {
      favoritos.splice(idx, 1);
    } else {
      favoritos.push(dorsal);
    }
    this.setState({ favoritos });
    Cookies.set('favoritos-' + competicionId, JSON.stringify(favoritos), { path: '/', expires: 30 });
  }

  onClickBack() { this.props.navigate(-1); }
  onSelectBoton(index) { this.setState({ botonSeleccionado: index }); }

  renderDetailTable(props) {
    switch (this.state.botonSeleccionado) {
      case 1: return <ResultadoDetailTablaPasos {...props} />;
      case 2: return <ResultadoDetailTablaPuestos {...props} />;
      case 3: return <ResultadoDetailTablaRankings rankingsResultados={this.state.rankingsResultados} />;
      default: return <div />;
    }
  }

  render() {
    const { evento, competicion, controlList, sectores, resultado } = this.state;

    if (resultado && competicion) {
      const prevision = calculaPrevision(competicion, controlList, sectores, resultado, null);
      return (
        <div>
          <TopHeaderMenu
            onClickBack={this.onClickBack.bind(this)}
            onClickShare={this.toogleSharePanel.bind(this)}
            competicion={competicion}
            selected={1}
            evento={evento}
          />
          <CompeticionHeaderMenu competicion={competicion} selected={4} evento={evento} />
          <div className="min-h-screen pt-28">
            <ResultadoDetailHeader
              resultado={resultado}
              esFavorito={this.esFavorito()}
              onClickFavorito={this.onClickFavorito.bind(this)}
            />
            <ResultadoDetailTiempo
              resultado={resultado}
              competicion={competicion}
              guntime={competicion.guntime}
              fechaInicio={competicion.fecha_inicio}
              prevision={prevision}
              controles={controlList}
            />
            <ResultadoDetailMenu
              resultado={resultado}
              controlList={controlList}
              tieneRankings={competicion.ranking_numero > 0}
              onSelectBoton={this.onSelectBoton.bind(this)}
              botonSeleccionado={this.state.botonSeleccionado}
            />
            {this.renderDetailTable({ competicion, resultado, prevision, sectores, controlList })}
          </div>
          {this.state.showSharePanel && (
            <SharePanel
              close={this.toogleSharePanel.bind(this)}
              url={`/competicion/${competicion.id}/dorsal/${resultado.dorsal}`}
              title={`Resultados en vivo de ${resultado.nombre} ${resultado.apellidos} en ${evento.nombre}.`}
            />
          )}
        </div>
      );
    } else {
      return <MsgNetLoading />;
    }
  }
}

function ResultadoScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <ResultadoScreenClass navigate={navigate} params={params} />;
}

export default ResultadoScreen;
